import PsychologyIcon from '@mui/icons-material/Psychology';
import { Button } from '@mui/material';
import { useState } from 'react';
import { AiSmartReplyContactPlanState } from '../../../../sic-lib/types/Ai';
import { Contact } from '../../../../sic-lib/types/Contact';
import { UserInfo } from '../../../../sic-lib/types/UserConfig';
import { SmartReplyDialog } from '../SmartReply/SmartReplyDialog';

interface Props {
    contact: Contact;
    activePlans: AiSmartReplyContactPlanState[] | undefined;
    isAdmin: boolean;
    userName: string;
    users: UserInfo[];
    hasAiFeature: boolean;
}

export default function AiSmartReplyActivationControls({
    contact,
    activePlans,
    isAdmin,
    userName,
    users,
    hasAiFeature,
}: Props) {
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

    const handleClick = () => {
        setIsDialogOpen(true);
    };
    const handleClose = () => {
        setIsDialogOpen(false);
    };

    return (
        <>
            <Button
                onClick={handleClick}
                variant="outlined"
                color="primary"
                startIcon={<PsychologyIcon />}
            >
                AI Smart Reply
            </Button>
            <SmartReplyDialog
                isDialogOpen={isDialogOpen}
                onCloseHandler={handleClose}
                activePlans={activePlans}
                contact={contact}
                isAdmin={isAdmin}
                userName={userName}
                users={users}
                hasAiFeature={hasAiFeature}
            />
        </>
    );
}
